import React from 'react';
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { strings } from '../../../resources/strings';
import { ProductRecipeLinkingRequest } from '../../../models/ProductRecipeLinkingRequest';
import { Table } from '../../../common-components/Table/Table';
import { TableData } from '../../../common-components/TableData/TableData';
import { TableHead } from '../../../common-components/TableHead/TableHead';
import { TableRow } from '../../../common-components/TableRow/TableRow';
import { Button } from '../../../common-components/Button/Button';
import { Container } from './styles';

interface ICardLinksRecipeByProductProps {
  linkingRequests?: ProductRecipeLinkingRequest[];
  deleteLinking?: (linking: ProductRecipeLinkingRequest) => void;
}

const CardLinksRecipeByProduct: React.FC<ICardLinksRecipeByProductProps> = ({
  children,
  linkingRequests,
  deleteLinking
}) => {

  const links = React.useMemo(() => {
    if (!linkingRequests || linkingRequests.length === 0) return null;
    return linkingRequests.map(lr => {
      const frameItem = lr.items.find(i => i.orderItem && i.orderItem.sku === lr.frameSku)?.orderItem;
      const frameName = frameItem?.name || lr.frameSku;
      const lensItem = lr.items.find(i => i.orderItem && i.orderItem.sku === lr.lensSku)?.orderItem;
      const lensName = lensItem?.name || lr.lensSku;
      return (
        <TableRow borderTop='1px solid #dee2e6' key={`tr-link-${lr.id}`}>
          <TableData backgroundColor='#fbfbfb' padding='2px 10px'>{frameName}</TableData>
          <TableData backgroundColor='#fbfbfb' padding='2px 10px'>{lensName}</TableData>
          <TableData backgroundColor='#fbfbfb' padding='2px 10px'>{lr.linkConfirmed ? strings.Yes : strings.Not}</TableData>
          <TableData backgroundColor='#fbfbfb' padding='2px 10px'>
            {deleteLinking ? (
              <Button title={strings.Delete} type='secondary' icon={faTrashAlt} colorIcon='#555' click={() => deleteLinking && deleteLinking(lr)} />
            ) : null}
          </TableData>
        </TableRow>
      );
    });
  }, [linkingRequests, deleteLinking]);

  return (
    <Container>
      <Table bordered borderBottom='0px'>
        <thead>
          <TableRow>
            <TableHead width='45%' padding='0px 10px'>{strings.Frame}</TableHead>
            <TableHead width='40%' padding='0px 10px'>{strings.Lens}</TableHead>
            <TableHead width='10%' padding='0px 10px'>{strings.Confirmed}</TableHead>
            <TableHead width='5%' padding='0px 10px'></TableHead>
          </TableRow>
        </thead>
        <tbody>
          {links}
        </tbody>
      </Table>
      {children}
    </Container>
  );
}

export {CardLinksRecipeByProduct};